<template>
<!--   <v-container> -->
  <div>
    <v-btn
      @click.stop="showHeadFilters"
      class="qmkey-btn-avanced-filters"
      :class="active ? 'qmkey-btn-avanced-filters-active' : ''"
    >
      Filter
      <v-icon right class="icon-large">mdi-tune-vertical</v-icon>
    </v-btn>
    <!-- Add /edit dialog -->
    <v-dialog
      id="headfilters"
      max-width="400px"
      ref="headfilters"
      v-model="showFilterForm"
      @keydown.esc="close"
      persistent
    >
      <v-card
        class="mx-auto"
        :loading="loading">
        <v-card-title>
          <span class="qmkey-modal-h1 pb-0">Filter Conditions</span>
          <v-spacer></v-spacer>
          <v-btn class="qmkey-modal-dialog-close" text plain right small :ripple="false" @click="close">
              <v-icon :ripple="false" small>mdi-close</v-icon>
          </v-btn> 
        </v-card-title>
        <v-card-text>
          <v-form
            id="head_filter_form"
            ref="headfilterform"
            @submit="setHeadFilters"
          >
            <input
              type="hidden"
              name="business_process"
              id="business_process"
              v-bind:value="current_business_process"
            />
            <v-row
              dense
              v-for="field in filter_fields_to_collect"
              :key="field.id"
            >
              <v-col>
                <component
                  v-bind:is="field.component"
                  :ref="field.id"
                  :id="field.id"
                  :props="field"
                ></component>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions class="qmkey-modal-dialog-card-actions">
          <v-spacer></v-spacer>
          <v-btn @click="cancelHeadFilters"
            class="qmkey-modal-dialog-button-secundary"
          >
            Clear
          </v-btn>
          <v-btn
            class="qmkey-modal-dialog-button-submit"
            text
            @click="setHeadFilters"
          >
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
<!--   </v-container> -->
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import QUnit from '@/api/QUnit'
import TextInput from '@/components/inputs/TextInput'
import Select from '@/components/inputs/Select'
import DateInput from '@/components/inputs/DateInput'
import TextareaInput from '@/components/inputs/TextareaInput'
import NumericInput from '@/components/inputs/NumericInput'
import FileInput from '@/components/inputs/FileInput'
import ProcessDependingUserField from '@/components/inputs/ProcessDependingUserField'
import DirectoryInput from '@/components/inputs/DirectoryInput'
import Tag from '@/components/inputs/Tag'

export default {
  components: {
    TextInput,
    Select,
    DateInput,
    TextareaInput,
    NumericInput,
    FileInput,
    ProcessDependingUserField,
    DirectoryInput,
    Tag,
  },
  name: 'ExplorerHeaderAdvancedFilter',
  data() {
    return {
      error_message: '',
      menu_context: '',
      filter_fields_to_collect: [],
      filter_form_error_message: '',
      jsData: '',
      showFilterForm: false,
      loading: false,
      formData: {},
      active: false,
    }
  },
  computed: {
    ...mapGetters(['isUser', 'isManager', 'isAdmin']),
    ...mapState([
      'current_unit',
      'current_business_process',
      'filtersFormData',
      'sitePath',
      'processID',
      'searchText',
    ]),
  },
  mounted: function() {
    // this.REFRESH_STATE(this)
  },
  updated: function() {
    if (this.jsdata) {
      var jsscript = document.createElement('script')
      jsscript.innerText = this.jsdata
      document.head.appendChild(jsscript)
    }
  },
  methods: {
    close: function() {
      this.$refs.headfilterform.reset()
      this.message = ''
      this.alert = false
      this.showFilterForm = false
    },       
    cancelHeadFilters(evt) {
      this.$refs.headfilterform.reset()
    },
    setHeadFilters(evt) {
      var fdata = new FormData()
      let value = null
      this.active = false
      for (const field of this.filter_fields_to_collect) {
        if (field.hidden) fdata.append(field.id, field.value)
        else {
          value = document.getElementById(field.id).__vue__.value
          if (value !== undefined && value != null  && value != "") {
            console.log('DEBUG Filter.get_data(): field=', field.id, value)          
            fdata.append(field.id, value)
            this.active = true
          }
        }
      }
      this.SET_FILTER_FORM(fdata)
      this.$emit("input", fdata)
      this.showFilterForm = false      
    },
    showHeadFilters(evt) {
      this.filter_form_error_message = ''
      this.showFilterForm = true      
      var business_process = this.current_business_process
      if (business_process)
        QUnit.getFieldsToCollectForFiltering(this.sitePath, business_process)
          .then(data => {
            this.filter_fields_to_collect = data['fields']
            this.jsdata = data['js']
          })
          .catch(
            error =>
              (this.filter_form_error_message =
                error.body || error.response.data),
          )
    },
    ...mapActions(['GET_SITES', 'REFRESH_STATE', 'EXPLORE_UNITS']),
    ...mapMutations([
      'SET_FILTER_FORM',
    ]),
  },
}
</script>


<style lang="scss">
    @import "@/sass/explorer.scss";
</style>
